<template>
    <v-container style="height: 100%; width: 100%;" fluid class="pa-0 ma-0">
        <v-container color="#FFA500" class="pa-0 ma-0" style="width: 100%;" fluid>

            <v-toolbar id="exploretool" color="#FFA500" flat dense class="pb-0">
                <v-toolbar-items>
                    <v-btn text @click="setnavbar" color="black"><v-icon>menu</v-icon></v-btn>
                    <div class="pa-1 mx-5 black--text menuhead" text tile>MANAGE</div>

                    <v-btn class="px-10" text tile v-bind:style="[togglecontacts ? {'background':'#FFD375', 'color':'black'} : {'color':'black'}]" @click='setMode("Contacts")'>Contacts</v-btn>
                    <v-btn class="px-0" v-if="togglecontacts" tile style="background: #FFD375; color:black;" icon @click='addNew("Contact")'>
                        <v-icon color="black">add_circle</v-icon>
                    </v-btn>

                    <v-btn class="px-10" text tile v-bind:style="[togglegroups ? {'background':'#FFD375', 'color':'black'} : {'color':'black'}]" @click='setMode("Groups")'>Groups</v-btn>
                    <v-btn class="px-0" v-if="togglegroups" tile style="background: #FFD375; color:black;" icon @click='addNew("Group")'>
                        <v-icon color="black">add_circle</v-icon>
                    </v-btn>
                    <v-btn class="px-10" text tile v-bind:style="[togglesurveys ? {'background':'#FFD375', 'color':'black'} : {'color':'black'}]" @click='setMode("Surveys")'>Surveys</v-btn>
                    <v-btn class="px-10" text tile v-bind:style="[toggleshares ? {'background':'#FFD375', 'color':'black'} : {'color':'black'}]" @click='setMode("Shares")'>Shares</v-btn>
                    <v-btn class="px-0" v-if="toggleshares" tile style="background: #FFD375; color:black;" icon @click='addNew("Share")'>
                        <v-icon color="black">add_circle</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container pa-0 ma-0 style="height: 95%; width: 100%;" fluid>
                <component :is="detailvue"></component>
            </v-container>

            <ContactPopup v-bind:selectedcontact=selectedcontact v-model="showContactPopup" />
            <GroupPopup v-bind:selectedgroup=selectedgroup v-model="showGroupPopup" />
            <SharePopup v-bind:selectedshare=selectedshare v-model="showSharePopup" />

        </v-container>
     </v-container>
</template>

<script>

    import ManageContacts from '@/views/Manage/Contacts/ManageContacts';
    import ManageGroups from '@/views/Manage/Groups/ManageGroups';
    import ManageSurveys from '@/views/Manage/Surveys/ManageSurveys';
    import ManageShares from '@/views/Manage/Shares/ManageShares';
    import ContactPopup from '@/views/Manage/Contacts/ContactPopup';
    import GroupPopup from '@/views/Manage/Groups/GroupPopup';
    import SharePopup from '@/views/Manage/Shares/SharePopup';

    import '@/general.js';
    import { dateticks, firebaseid, sharename, digit2 } from '@/functions.js';

export default {
    name: 'Manage',
    mounted:function(){
        this.$store.state.heading="Manage";
    },
    data() {
        return {        
            detailvue:'',   
            togglecontacts:false,
            togglegroups:false,
            togglesurveys:false,
            toggleshares:false,
            toggleaccount: false,
            selectedcontact: null,
            selectedgroup: null,
            selectedshare: null,
            showContactPopup: false,
            showGroupPopup: false,
            showSharePopup: false
        };
    },
    components:{
        ManageContacts,
        ManageGroups,
        ManageSurveys,
        ManageShares,
        ContactPopup,
        GroupPopup,
        SharePopup
    },
        methods: {
            setnavbar() {
                this.$store.state.navpage.setnavbar();
            },
            setMode(mode) {
                if (mode === 'Surveys') {
                    this.$store.state.undermanagement = true;
                }
                if (this.$store.state.selectedcontact != null) {
                    this.$store.state.selectedcontact.IsSelected = false;
                    this.$store.state.selectedcontact = null;
                }
                this.selectedcontact = null;
                this.$store.state.selectedcontact = null;

                if (this.$store.state.selectedgroup != null) {
                    this.$store.state.selectedgroup.IsSelected = false;
                    this.$store.state.selectedgroup = null;
                }
                this.selectedgroup = null;
                this.$store.state.selectedgroup = null;

                if (this.$store.state.selectedshare != null) {
                    this.$store.state.selectedshare.IsSelected = false;
                    this.$store.state.selectedshare = null;
                }
                this.selectedshare = null;
                this.$store.state.selectedshare = null;

                this.detailvue = 'Manage' + mode;
                this.togglecontacts=false;
                this.togglegroups=false;
                this.togglesurveys=false;
                this.toggleshares=false;
                this.toggleaccount=false;
                if (mode === 'Contacts') this.togglecontacts=true;
                if (mode === 'Groups') this.togglegroups=true;
                if (mode === 'Surveys') {
                    this.togglesurveys = true;
                }
                if (mode === 'Shares') this.toggleshares=true;
                if (mode === 'Account') this.toggleaccount=true;
            },
            addNew(mode){
                if (mode == "Contact") {
                    this.selectedcontact = null;
                    this.showContactPopup = true;
                }
                else if (mode == "Group") {
                    this.selectedgroup = null;
                    this.showGroupPopup = true;
                }
                else if (mode == "Share") {
                    this.selectedshare = new Object();
                    var ticks = dateticks();
                    this.selectedshare.CreatorID = this.$store.state.user.uid;
                    this.selectedshare.Name = sharename(this.$store.state.currentuser.Tag);
                    this.selectedshare.ShareTime = 0;
                    this.selectedshare.ID = firebaseid(ticks);
                    this.showSharePopup = true;
                }
                else
                    alert("addNew " + mode);
            }
    }
}

</script>

<style>
    .menuhead {
        font-size: 1.5em;
        font-weight:bold;
    }
</style>